import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export default class UspBar {

    constructor() {

        this.settings = {
            $slider : $('.js-usp-bar')
        };

        this.bindUIActions();
    }

    bindUIActions() {

        if(this.settings.$slider.length) {
            new Swiper('.js-usp-bar', {
                modules: [Navigation],
                direction: 'horizontal',
                loop: true,
                slidesPerView: 1,
                spaceBetween: 10,
                breakpoints: {
                    768: {
                        slidesPerView: 2
                    },
                    1024: {
                        slidesPerView: 4
                    }
                },

                // Navigation arrows
                navigation: {
                    nextEl: '.js-usp-next',
                    prevEl: '.js-usp-prev',
                },
            });
        }

    }

};

new UspBar();